import {ComplaintModel} from './complaint.model';
import {FormsModel} from './forms.model';
import {DamagedModel} from './damaged.model';
import {CounterpartyModel, CounterpartyModelDTO} from './counterparty.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {DeponentModel} from './deponent.model';
import {WoundedModel} from './wounded.model';
import {NoteModel} from './note.model';
import {StatusModel} from './status.model';
import {CaiModel} from './cai.model';
import {FoundModel} from './found.model';
import {RefundModel} from './refund.model';
import {TheftModel} from './theft.model';
import {AppropriationPracticeCar} from './appropriation-practice-car.model';
import {ExemptionModel} from './exemption.model';
import {ClaimsAuthorityWorkingDetailModel} from './claims-authorty-working.model';
import { ClaimsFileType } from './file.model';
import { AccidentType } from './accident.model';

export class ClaimModel {
	id: string;
	forced?: boolean;
	id_saleforce?: any;
	in_evidence?: boolean;
	status: ClaimsStatus;
	is_with_counterparty?: boolean;
	practice_id: number;
	data_found: FoundModel;
	type: ClaimsType;
	complaint: ComplaintModel;
	forms: FormsModel;
	forms_lp?: FormsModel;
	damaged: DamagedModel;
	deponent: DeponentModel[];
	wounded: WoundedModel[];
	counterparty: CounterpartyModel[];
	created_at: Date;
	update_at: Date;
	notes: NoteModel[];
	historical: StatusModel[];
	cai_details: CaiModel;
	pai_comunication: boolean;
	legal_comunication?: boolean;
	metadata: any;
	refund: RefundModel;
	exemption?: ExemptionModel;
	theft?: TheftModel;
	appropriation_practice_car?: AppropriationPracticeCar[];
	with_continuation: boolean;
	authorities: ClaimsAuthorityWorkingDetailModel[];
	is_authority_linkable: boolean;
	motivation?: string;
	po_variation: boolean;
	total_miles_franchise: number;
	is_pending: boolean;
	attachments: ClaimsAttachmentsModel[];
	info_lp?: any;
	claims_no_miles?: any;
	archived: boolean;

	// aggiungere anche a dto sotto per il corretto funzionamento della put
	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			Object.assign(this, model);
		} else {
			this.complaint = new ComplaintModel();
			this.damaged = new DamagedModel();
			this.data_found = new FoundModel();
			this.counterparty = [];
			this.cai_details = new CaiModel();
			this.notes = [];
			this.deponent = [];
			this.wounded = [];
		}
	} 
	
	/**
	 * Controlla il tipo di Denuncia, che è diverso dal ClaimsType
	 * 
	 * @param {AccidentType[]} typeAccidentList
	 * @returns {boolean} 
	 */
	hasTypeAccident(typeAccidentList: AccidentType[]): boolean {

		if (Utilities.isEmpty(typeAccidentList)) {
			return false;
		}

		const currentTypeAccident = this.complaint.data_accident.type_accident;

		if (Utilities.isEmpty(currentTypeAccident)) {
			return false;
		}

		return typeAccidentList.includes(currentTypeAccident as AccidentType);
	}

	/**
	 * Controlla il tipo di Denuncia, che è diverso dal ClaimsType
	 * 
	 * @param {AccidentType[]} typeAccidentList
	 * @returns {boolean} 
	 */
	static hasTypeAccident__static(claimInput: ClaimModel, typeAccidentList: AccidentType[]): boolean {

		if (Utilities.isEmpty(typeAccidentList)) {
			return false;
		}

		const currentTypeAccident = claimInput.complaint.data_accident.type_accident;

		if (Utilities.isEmpty(currentTypeAccident)) {
			return false;
		}

		return typeAccidentList.includes(currentTypeAccident as AccidentType);
	}
}


export const ClaimValidated: string = 'VALIDATED';
export const ClaimRobberyFound: string = 'FINDING';
export const ClaimInsert: string = 'INSERT';
export const ClaimSentToCustomer: string = 'CLOSED_TOTAL_REFUND';
export const ClaimInsertIncomplete: string = 'COMPLAINT_INCOMPLETE_INSERTION';

export enum ClaimsStatus {
	TO_VALID = 'WAITING_FOR_VALIDATION',
	WAITING_FOR_AUTHORITY = 'WAITING_FOR_AUTHORITY',
	DRAFT = 'DRAFT',
	DELETED = 'DELETED',
	TO_ENTRUST = 'TO_ENTRUST',
	CLOSED = 'CLOSED',
	INCOMPLETE = 'INCOMPLETE',
	CLOSED_PRACTICE = 'CLOSED_PRACTICE',
	REJECTED = 'REJECTED',
	MANAGED = 'MANAGED',
	// WAIT_TO_RETURN_POSSESSION = 'WAIT_TO_RETURN_POSSESSION',
	// KASKO ='KASKO',
	// TO_REREGISTER = 'TO_REREGISTER',
	// TO_REREGISTER_CLOSED = 'TO_REREGISTER_CLOSED',
	// LOST_POSSESSION = 'LOST_POSSESSION',
	// PROPOSED_ACCEPTED = 'PROPOSED_ACCEPTED',
	// WAIT_LOST_POSSESSION = 'WAIT_LOST_POSSESSION',
	// RETURN_TO_POSSESSION = 'RETURN_TO_POSSESSION',
	WAITING_FOR_REFUND = 'WAITING_FOR_REFUND',
	TO_SEND_TO_CUSTOMER = 'TO_SEND_TO_CUSTOMER',
	CLOSED_PARTIAL_REFUND = 'CLOSED_PARTIAL_REFUND',
	CLOSED_TOTAL_REFUND = 'CLOSED_TOTAL_REFUND',
	// TO_WORK = 'TO_WORK',
	// BOOK_DUPLICATION = 'BOOK_DUPLICATION',
	// BOOK_DUPLICATION_CLOSED = 'BOOK_DUPLICATION_CLOSED',
	// STAMP = 'STAMP',
	// STAMP_CLOSED = 'STAMP_CLOSED',
	// DEMOLITION = 'DEMOLITION',
	// DEMOLITION_CLOSED = 'DEMOLITION_CLOSED'
}

export enum ClaimsType {
	FUL = 'FUL',
	FNI = 'FNI',
	FCM = 'FCM',
	NO = 'NO',
}

export enum StatsStatus {
	TO_VALID = 'WAITING_FOR_VALIDATION',
	INCOMPLETE = 'INCOMPLETE',
	WAITING_FOR_AUTHORITY = 'WAITING_FOR_AUTHORITY',
	TO_ENTRUST = 'TO_ENTRUST',
	PO_VARIATION = 'PO_VARIATION',
	WAITING_FOR_REFUND = 'WAITING_FOR_REFUND',
	WAITING_FOR_NUMBER_SX = 'WAITING_FOR_NUMBER_SX',
	TO_SEND_TO_CUSTOMER = 'TO_SEND_TO_CUSTOMER'
}

export const ClosedPartialRefund: string = 'CLOSED_PARTIAL_REFUND';

export enum TotalStatItem {
	TOT_CLAIMS = 'totClaims',
	TOT_IN_EVIDENCE = 'totInEvidence',
	TOT_WITH_CONTINUATION = 'totWithContinuation',
	TOT_WITH_CONTINUATION_IN_EVIDENCE = 'totWithContinuationInEvidence'
}

export enum ComunicationType {
	PAI = 'PAI',
	LEGAL_COST = 'LEGAL_COST',
	FINDING = 'FINDING'
}

export enum CommunicationStatus {
	TO_BE_PROCESSED =  'TO_BE_PROCESSED',
	TO_BE_RECOVERED =  'TO_BE_RECOVERED',
	RECOVERED = 			 'RECOVERED',
	OUTDATED = 			   'OUTDATED',
	SEND_OK = 				 'SEND_OK',
}

export class ClaimModelDTO {
	id: string;
	forced?: boolean;
	id_saleforce?: any;
	in_evidence?: boolean;
	status: ClaimsStatus;
	is_with_counterparty?: boolean;
	practice_id: number;
	data_found: FoundModel;
	type: ClaimsType;
	complaint: ComplaintModel;
	forms: FormsModel;
	forms_lp?: FormsModel;
	damaged: DamagedModel;
	deponent: DeponentModel[];
	wounded: WoundedModel[];
	counterparty: CounterpartyModelDTO[];
	created_at: Date;
	update_at: Date;
	notes: NoteModel[];
	historical: StatusModel[];
	cai_details: CaiModel;
	pai_comunication: boolean;
	legal_comunication?: boolean;
	metadata: any;
	refund: RefundModel;
	exemption?: ExemptionModel;
	theft?: TheftModel;
	appropriation_practice_car?: AppropriationPracticeCar[];
	with_continuation: boolean;
	authorities: ClaimsAuthorityWorkingDetailModel[];
	is_authority_linkable: boolean;
	motivation?: string;
	po_variation: boolean;
	total_miles_franchise: number;
	info_lp?: any;
	claims_no_miles?: any;

	constructor(model: any) {
			if (model.counterparty && model.counterparty.length > 0) {
				model.counterparty = model.counterparty.map(ctp => new CounterpartyModelDTO(ctp));
			}
			Object.assign(this, model);
	}
}

interface ClaimsAttachmentsModel {
	blob_type: string,
	description: ClaimsFileType.COMPLAINT | ClaimsFileType.PHOTO | ClaimsFileType.OTHER | ClaimsFileType.CAI | ClaimsFileType.ACCIDENTAL_DECLARATION,
	file_name: string
}
